<div>
  {{data.data | json}}
</div>
